import { useLazyGetOfflineRequestsStatusQuery } from "../../../services/api/offlineApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../services/store";
import { useEffect, useRef } from "react";

export function useNetworkReconnectStatusCheck() {
  const networkState = useSelector(
    (state: RootState) => state.network?.networkState,
  );
  const [getOfflineRequestsStatus] = useLazyGetOfflineRequestsStatusQuery();
  const networkReachable = networkState?.isInternetReachable;
  const wasNetworkReachable = useRef<boolean>(undefined);

  useEffect(() => {
    if (!wasNetworkReachable.current && networkReachable) {
      getOfflineRequestsStatus();
    }

    wasNetworkReachable.current = networkReachable;
  }, [networkReachable, getOfflineRequestsStatus]);
}
